export default __webpack_public_path__ + "static/media/flag-hungary.ac3c1db7.svg";